// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"ApplicationTabs_tabsContainer__3PnGh","tabContainer":"ApplicationTabs_tabContainer__25pSk","skeletonTabsContainer":"ApplicationTabs_skeletonTabsContainer__3k5rP"};